import PopupWithForm from "./PopupWithForm.jsx";
import { slugToText } from "../../utils/slugify.js";

function DeleteNotePopup({isOpen, onClose, onDelete, note, getNoteTitle,}) {
  const noteTitle = typeof getNoteTitle === "function" ? getNoteTitle(note) : slugToText(note?.videoSlug || "");
  const handleDelete = (e) => {
    e.preventDefault();
    if (!note) return;
    onDelete(note);
  };

  return (
    <PopupWithForm
      isOpen={isOpen}
      onClose={onClose}
      name="delete-note"
      title="Delete Note"
      buttonText=""
      isButtonEnabled={true}
      hideDefaultButton={true}
      onSubmit={handleDelete}
    >
      <p>Do you confirm deleting your notes on lesson:</p>
      <strong>{noteTitle}</strong>
      <div className="popup__confirm-buttons">
        <button  className="popup__button"
          type="button"
          onClick={handleDelete}
        > Delete
        </button>
        <button className="popup__button popup__button_cancel"
          type="button"
          onClick={onClose}
        > Exit
        </button>
      </div>
    </PopupWithForm>
  );
}

export default DeleteNotePopup;